import { render, staticRenderFns } from "./Depository.vue?vue&type=template&id=17475927&lang=pug&"
import script from "./Depository.vue?vue&type=script&lang=ts&"
export * from "./Depository.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports